// ** Third Party Components
import Cookies from "js-cookie";

// ** Config
import configGlobal from "configuration";

// #####################################################

const LOCALSTORAGE_KEY = "isInstallSuccessPWA";
const isSSR = typeof window === "undefined";
const installSuccessPWAConfig = configGlobal.installSuccessPWA;
let migrated = false;

// ** Migrates install success status from localStorage to cookie if exists
const migrateFromLocalStorage = () => {
	if (migrated || isSSR || !localStorage) {
		return;
	}

	try {
		const localStorageValue = localStorage.getItem(LOCALSTORAGE_KEY);
		if (localStorageValue) {
			Cookies.set(
				installSuccessPWAConfig.cookieName,
				localStorageValue,
				installSuccessPWAConfig.cookieOptionsJsCookie,
			);
			localStorage.removeItem(LOCALSTORAGE_KEY);
		}
	} catch (error) {
		// ** Intentionally ignored: non-critical failure.
	} finally {
		migrated = true;
	}
};

// ** Gets the install success status, performing migration if needed.
export const getInstallSuccessPWA = () => {
	if (isSSR) return false;

	migrateFromLocalStorage();

	try {
		const value = Cookies.get(installSuccessPWAConfig.cookieName);
		return value === "true";
	} catch (error) {
		return false;
	}
};

// ** Sets the install success status in cookie.
export const setInstallSuccessPWA = (status = true) => {
	if (isSSR) return;

	try {
		Cookies.set(
			installSuccessPWAConfig.cookieName,
			status.toString(),
			installSuccessPWAConfig.cookieOptionsJsCookie,
		);
	} catch (error) {
		// ** Intentionally ignored: non-critical failure.
	}
};
